var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.625C15.9525 9.625 17.1163 8.4525 17.1163 7C17.1163 5.5475 15.9525 4.375 14.5 4.375C13.0475 4.375 11.875 5.5475 11.875 7C11.875 8.4525 13.0475 9.625 14.5 9.625ZM7.5 9.625C8.9525 9.625 10.1163 8.4525 10.1163 7C10.1163 5.5475 8.9525 4.375 7.5 4.375C6.0475 4.375 4.875 5.5475 4.875 7C4.875 8.4525 6.0475 9.625 7.5 9.625ZM7.5 11.375C5.46125 11.375 1.375 12.3988 1.375 14.4375V16.625H13.625V14.4375C13.625 12.3988 9.53875 11.375 7.5 11.375ZM14.5 11.375C14.2463 11.375 13.9575 11.3925 13.6512 11.4188C14.6663 12.1538 15.375 13.1425 15.375 14.4375V16.625H20.625V14.4375C20.625 12.3988 16.5387 11.375 14.5 11.375Z",
    fill: "#178EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePeopleIcon);
export default __webpack_public_path__ + "static/media/active-people-icon.da789442ade1580d2ce6fec2fbda7064.svg";
export { ForwardRef as ReactComponent };